import React from 'react'
import { Container, Nav, Row, Col, Card } from 'react-bootstrap'
import { SearchBar } from '../components/SearchBar';
import { Page } from '../components/Page';

function Home(props) {

    return (
        <Page home={true}>
            <Row className="justify-content-md-center align-items-center" style={{ height: 300 }}>
                <Col>
                    <Card className="pb-4" style={{ width: '64rem' }} bg="transparent">
                        <Card.Body >
                            <h1 className="d-flex header justify-content-center mb-3" >
                                <img
                                    alt=""
                                    src="../../logo_bw.svg"
                                    width="40"
                                    height="40"
                                    className="d-inline-block align-center"
                                />{' '}
                                FratRank
                            </h1>
                            <Nav className='d-flex justify-content-center mb-3'>
                                <SearchBar nav={"redirect"} />
                            </Nav>
                            <Card.Link className="d-flex header justify-content-center" href="/compare">Compare a frat</Card.Link>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Page>
    )
}

export { Home }